import React from 'react';
const benefits = [{
  icon: '🧭',
  title: 'Claridad',
  desc: 'Vas a entender por qué reaccionás como reaccionás y dejar de culparte.'
}, {
  icon: '🛡️',
  title: 'Límites',
  desc: 'Vas a poder decir que no y priorizarte sin sentir esa culpa paralizante.'
}, {
  icon: '🧠',
  title: 'Calma',
  desc: 'Vas a tener herramientas para regular la ansiedad cuando se dispare.'
}, {
  icon: '🧱',
  title: 'Autoestima',
  desc: 'Vas a construir seguridad desde adentro, no esperando validación externa.'
}, {
  icon: '💬',
  title: 'Comunicación',
  desc: 'Vas a expresar lo que necesitás de forma clara, sin explotar ni implosionar.'
}, {
  icon: '🌿',
  title: 'Vínculos',
  desc: 'Vas a aprender a elegir mejor y sostener relaciones estables y recíprocas.'
}];
export function BenefitsSection() {
  return <section className="py-20 px-4 bg-[#0a0a0e]" data-id="element-14">
      <div className="max-w-6xl mx-auto" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-17">
            Qué va a cambiar en vos
          </h2>
          <div className="h-1 w-20 bg-[#d4a853] mx-auto rounded-full" data-id="element-18"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-19">
          {benefits.map((benefit, index) => <div key={index} className="bg-white/5 border border-white/5 p-6 rounded-2xl hover:bg-white/10 transition-colors duration-300" data-id="element-20">
              <div className="text-4xl mb-4" data-id="element-21">{benefit.icon}</div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-22">
                {benefit.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-23">{benefit.desc}</p>
            </div>)}
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-r from-[#d4a853]/20 to-[#d4a853]/5 border border-[#d4a853]/30 p-8 rounded-2xl text-center" data-id="element-24">
          <p className="text-lg md:text-xl text-white font-medium" data-id="element-25">
            "Esto <span className="text-[#d4a853] font-bold" data-id="element-26">NO</span> es
            motivación vacía. Esto es un sistema práctico basado en psicología
            real para personas reales."
          </p>
        </div>
      </div>
    </section>;
}